import template from './business-data-form-template.html'
import controller from './business-data-form-controller'

angular.module('ngApp')
  .component('businessDataForm', { template, controller })
